import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { holdItemShape, bibShape, paginationShape } from '@bibliocommons/bc-prop-types';
import { Clock, Cancel } from '@bibliocommons/base-icons';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ReviewButton from '../ReviewButton';
import FullScreenOverlay from '@bibliocommons/base-full-screen-overlay';
import InactiveHoldsList from '../InactiveHoldsList';
import ItemField from '../../shared/ItemField/ItemField';
import ShortFormattedDate from '../../../shared/ShortFormattedDate';

import './HoldsToReview.scss';

export default class HoldsToReview extends BcReactComponent {
  static renderDateField(name, date) {
    const formattedDate = <ShortFormattedDate value={date} />;
    return <ItemField className="inactive-item-date" name={name} value={formattedDate} />;
  }

  static renderExpiredItemDetails(item) {
    const date = item.get('expiredDate');
    return date && HoldsToReview.renderDateField(
      <FormattedMessage id="holds_date_expired" />,
      date
    );
  }

  static renderCancelledItemDetails(item) {
    const date = item.get('cancelledDate');
    return date && HoldsToReview.renderDateField(
      <FormattedMessage id="holds_date_cancelled" />,
      date
    );
  }

  constructor(props) {
    super(props);

    this.bindAll(
      'handleShowExpiredOverlay',
      'handleCloseExpiredOverlay',
      'handleShowCancelledOverlay',
      'handleCloseCancelledOverlay',
      'handleUpdateExpiredPage',
      'handleUpdateCancelledPage'
    );

    this.state = {
      showExpiredOverlay: false,
      showCancelledOverlay: false
    };
  }

  handleShowExpiredOverlay() {
    const { accountId } = this.props;
    this.setState({ showExpiredOverlay: true }, () => {
      this.props.fetchExpiredHolds({ accountId });
    });
  }

  handleCloseExpiredOverlay() {
    this.setState({ showExpiredOverlay: false });
  }

  handleShowCancelledOverlay() {
    const { accountId } = this.props;
    this.setState({ showCancelledOverlay: true }, () => {
      this.props.fetchCancelledHolds({ accountId });
    });
  }

  handleCloseCancelledOverlay() {
    this.setState({ showCancelledOverlay: false });
  }

  handleUpdateExpiredPage(page) {
    const { accountId } = this.props;
    this.props.fetchExpiredHolds({ accountId, page });
  }

  handleUpdateCancelledPage(page) {
    const { accountId } = this.props;
    this.props.fetchCancelledHolds({ accountId, page });
  }

  renderExpiredButton() {
    const { expiredCount } = this.props;
    return (expiredCount > 0) && (
      <ReviewButton
        className="expired-button"
        handleClick={this.handleShowExpiredOverlay}
        title={
          <span>
            <Clock className="holds-expired-icon" />
            <FormattedMessage id={expiredCount === 1 ? 'holds_number_expired_singular' : 'holds_number_expired_plural'} values={{ count: expiredCount }} />
          </span>
        } />
    );
  }

  renderCancelledButton() {
    const { cancelledCount } = this.props;
    return (cancelledCount > 0) && (
      <ReviewButton
        className="cancelled-button"
        handleClick={this.handleShowCancelledOverlay}
        title={
          <span>
            <Cancel className="holds-cancelled-icon" />
            <FormattedMessage id={cancelledCount === 1 ? 'holds_number_cancelled_singular' : 'holds_number_cancelled_plural'} values={{ count: cancelledCount }} />
          </span>
        } />
    );
  }

  renderTitle() {
    const { expiredCount, cancelledCount } = this.props;
    return (expiredCount > 0 || cancelledCount > 0) && (
      <h2 className="holds-to-review-heading">
        <FormattedMessage id="section_title_previously_on_hold" />
      </h2>
    );
  }

  renderExpiredOverlay() {
    const { expiredHolds, fetchingExpired, expiredHoldsPagination, bibs } = this.props;
    return (
      <FullScreenOverlay
        handleClose={this.handleCloseExpiredOverlay}
        open={this.state.showExpiredOverlay}>
        <InactiveHoldsList
          fetching={fetchingExpired}
          title={<FormattedMessage id="holds_expired" />}
          items={expiredHolds}
          bibs={bibs}
          handleUpdatePage={this.handleUpdateExpiredPage}
          pagination={expiredHoldsPagination}
          renderItemDetails={HoldsToReview.renderExpiredItemDetails} />
      </FullScreenOverlay>
    );
  }

  renderCancelledOverlay() {
    const { cancelledHolds, fetchingCancelled, cancelledHoldsPagination, bibs } = this.props;
    return (
      <FullScreenOverlay
        handleClose={this.handleCloseCancelledOverlay}
        open={this.state.showCancelledOverlay}>
        <InactiveHoldsList
          fetching={fetchingCancelled}
          title={<FormattedMessage id="holds_cancelled" />}
          items={cancelledHolds}
          bibs={bibs}
          handleUpdatePage={this.handleUpdateCancelledPage}
          pagination={cancelledHoldsPagination}
          renderItemDetails={HoldsToReview.renderCancelledItemDetails} />
      </FullScreenOverlay>
    );
  }

  render() {
    return (
      <div className="cp-holds-to-review">
        {this.renderTitle()}

        <div className="buttons">
          {this.renderExpiredButton()}
          {this.renderCancelledButton()}
        </div>

        {this.renderExpiredOverlay()}
        {this.renderCancelledOverlay()}
      </div>
    );
  }
}

HoldsToReview.propTypes = {
  expiredHolds: ImmutablePropTypes.listOf(holdItemShape),
  cancelledHolds: ImmutablePropTypes.listOf(holdItemShape),
  expiredCount: PropTypes.number,
  cancelledCount: PropTypes.number,
  fetchExpiredHolds: PropTypes.func,
  fetchCancelledHolds: PropTypes.func,
  fetchingExpired: PropTypes.bool,
  fetchingCancelled: PropTypes.bool,
  cancelledHoldsPagination: paginationShape,
  expiredHoldsPagination: paginationShape,
  bibs: ImmutablePropTypes.mapOf(bibShape),
  accountId: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsToReview/HoldsToReview.jsx